import { render } from "./JobtitleDropdown.vue?vue&type=template&id=24421173"
import script from "./JobtitleDropdown.vue?vue&type=script&lang=js"
export * from "./JobtitleDropdown.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__